<div class="d-none slider-progress-header">
    <!--barra de progress-->
    <div class="session__progress ">
        <span class="progress-bar">
            <span class="progress"
                [ngStyle]="{'width.%': (navigation.currentCourseSubscriptionSession.progress === null) ? 0 : navigation.currentCourseSubscriptionSession.progress}">
                <span class="progress-percentage">{{ navigation.currentCourseSubscriptionSession.progress === null ? 0 :
                    navigation.currentCourseSubscriptionSession.progress }} %</span>
            </span>
        </span>
    </div>
</div>

<!--
  DESHABILITADO: los botones Anterior/Siguiente de este componente fueron reemplazados
  por la barra unificada dentro de <msc-next-prev-btn>. Se conserva el TS y la barra
  de progreso (.slider-progress-header) intactos para no romper otras pantallas.
-->
<div class="slide__navigate d-none">
    <div class="session__progress d-none ">
        <span class="progress-bar">
            <span class="progress"
                [ngStyle]="{'width.%': (navigation.currentCourseSubscriptionSession.progress === null) ? 0 : navigation.currentCourseSubscriptionSession.progress}"></span>
        </span>

        <span class="progress-percentage">{{ navigation.currentCourseSubscriptionSession.progress === null ? 0 :
            navigation.currentCourseSubscriptionSession.progress }} %</span>
    </div>
    <!--previous -- next-->
    <div class="slide__actions">
        <div class="slide__navigate__previous">
            <a class="" (click)="goPrev()">
                <i class="icon icon-arrow-ios-back-outline"></i>
                {{ 'word.previous' | translate }}
            </a>
        </div>

        <div class="slide__navigate__next" [ngClass]="{'disabled': disabled}">
            <a class="" (click)="goNext()">
                {{ 'word.next' | translate }}
                <i class="icon icon-arrow-ios-forward-outline"></i>
            </a>
        </div>
    </div>
</div>